import { FC, memo } from 'react';
import {
  useRestoreDrawerAfterReturn,
  UseRestoreDrawerAfterReturnParams,
} from './useRestoreDrawerAfterReturn';

/**
 * Mount point for useRestoreDrawerAfterReturn: the hook needs
 * TriggerFindTargetReportProvider, which the list renders itself, so it runs
 * in this child instead of the list component. Renders nothing.
 */
export const RestoreDrawerAfterReturn: FC<UseRestoreDrawerAfterReturnParams> =
  memo((props) => {
    useRestoreDrawerAfterReturn(props);
    return null;
  });
RestoreDrawerAfterReturn.displayName = 'RestoreDrawerAfterReturn';
